import jApiLoginActivity from '../services/jApiLoginActivity';

const actions = {
  async getLoginActivityList({ dispatch }, params) {
    let res;
    try {
      res = await jApiLoginActivity.getLoginActivity(params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async forceLogout({ dispatch }, params) {
    let res;
    try {
      res = await jApiLoginActivity.forceLogout(params);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },
};


export default {
  namespaced: true,
  actions,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreLoginActivity.js